import axios from "axios";

const ROLE_PERMISSION_MANAGEMENT_SERVICE = process.env.REACT_APP_ROLE_PERMISSION_MANAGEMENT_MICROSERVICE_URL + process.env.REACT_APP_SERVICES_VERSION + '/rolepermissionmanagement';

export default function RolePermissionManagementService() {
}

export async function initialiseRolesAndPermissions(surveyUsersId) {

    const systemRoles = await getRdiSystemRoles();
    const systemPermissions = await getRdiSystemPermissions();
    const systemRolePermissions = await getRdiSystemRolePermissionsAll();
    const userRoles = await getRdiUserRoles(surveyUsersId);
    const userPermissions = await getRdiUserPermissions(surveyUsersId);

    localStorage.setItem('SystemRoles', JSON.stringify(systemRoles));
    localStorage.setItem('SystemPermissions', JSON.stringify(systemPermissions));
    localStorage.setItem('SystemRolePermissions', JSON.stringify(systemRolePermissions));
    localStorage.setItem('UserRoles', JSON.stringify(userRoles));
    localStorage.setItem('UserPermissions', JSON.stringify(userPermissions));

    return null;
}

export function userRolesCanActionResource(requiredRoleNames, requiredAction, requiredResource) {
    let hasUserRoleActive = false;
    let hasUserPermissionActiveGrantTypeAllow = false;
    let hasSystemPermissionActive = false;
    let hasSystemRolePermissionActiveGrantTypeAllow = false;

    if (localStorage.getItem('UserRoles') !== undefined && localStorage.getItem('UserRoles') !== null) {
        const userRoles = JSON.parse(localStorage.getItem('UserRoles'));

        // Check only the roles this user has
        userRoles.forEach(userRole => {
            let isActiveUserRole = false;

            // This role has to be a required role
            let isRequiredUserRole = (requiredRoleNames.some(roleName => roleName === userRole.role.name));

            if (isRequiredUserRole) {

                // This role has to be a active role
                isActiveUserRole = (userRole.role.active === true && userRole.surveysUser.active === true);

                if (isRequiredUserRole && isActiveUserRole) {
                    if (localStorage.getItem('SystemRolePermissions') !== undefined && localStorage.getItem('SystemRolePermissions') !== null) {
                        const systemRolePermissions = JSON.parse(localStorage.getItem('SystemRolePermissions'));

                        // The system role permission must be active and grant allowed
                        let isSystemRolePermissionActive = systemRolePermissions.some(systemRolePermission =>
                            systemRolePermission.role.id === userRole.role.id
                            && systemRolePermission.permission.action === requiredAction
                            && systemRolePermission.permission.resource === requiredResource
                            && systemRolePermission.permission.active === true
                            && systemRolePermission.grantType === 'ALLOW');

                        // Only then the user is active and rolePermission is active with grant allowed
                        if (isSystemRolePermissionActive) {
                            hasUserRoleActive = true;
                            hasSystemRolePermissionActiveGrantTypeAllow = true;
                        }
                    }
                }
            }
        });
    }

    // Make sure the user does have the permission and its active and grant allowed
    if (localStorage.getItem('UserPermissions') !== undefined && localStorage.getItem('UserPermissions') !== null) {
        const userPermissions = JSON.parse(localStorage.getItem('UserPermissions'));
        hasUserPermissionActiveGrantTypeAllow = userPermissions.some(userPermission => userPermission.permission.resource === requiredResource && userPermission.permission.action === requiredAction  && userPermission.permission.active === true && userPermission.grantType === 'ALLOW');
    }

    // Make sure the system permission is active
    if (localStorage.getItem('SystemPermissions') !== undefined && localStorage.getItem('SystemPermissions') !== null) {
        const systemPermissions = JSON.parse(localStorage.getItem('SystemPermissions'));
        hasSystemPermissionActive = systemPermissions.some(systemPermission => systemPermission.resource === requiredResource && systemPermission.action === requiredAction && systemPermission.active === true);
    }

    return (hasUserRoleActive && hasUserPermissionActiveGrantTypeAllow && hasSystemPermissionActive && hasSystemRolePermissionActiveGrantTypeAllow);
}

export async function getRdiSystemRoles() {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiroles';

    const rdiSystemRolesURL = axios.create({ baseURL: url });

    const systemRoles = await rdiSystemRolesURL.get('')
        .then(response => {
            const data = response.data

            return data;
        })
        .catch((e) => {
            console.error('Error loadiing all system roles!', e);
        });

    if (systemRoles !== null) {
        return systemRoles;
    }

    return null;
}

export async function getRdiSystemPermissions() {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdipermissions';

    const rdiSystemPermissionsURL = axios.create({ baseURL: url });

    const systemPermissions = await rdiSystemPermissionsURL.get('')
        .then(response => {
            const data = response.data

            return data;
        })
        .catch((e) => {
            console.error('Error loading all system permissions!', e);
        });

    if (systemPermissions !== null) {
        return systemPermissions;
    }

    return null;
}

export async function getRdiSystemRolePermissionsByRoleId(roleId) {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdirolepermissions/role/' + roleId;
    const rdiSystemRolePermissionsURL = axios.create({ baseURL: url });

    const systemRolePermissions = await rdiSystemRolePermissionsURL.get('')
        .then(response => {
            const data = response.data
            return data;
        })
        .catch((e) => {
            console.error('Error loading all system role-permissions!', e);
        });

    if (systemRolePermissions !== null) {
        return systemRolePermissions;
    }

    return null;
}

export async function getRdiSystemRolePermissionsAll() {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdirolepermissions/all';

    const rdiSystemRolePermissionsURL = axios.create({ baseURL: url });

    const systemRolePermissions = await rdiSystemRolePermissionsURL.get('')
        .then(response => {
            const data = response.data

            return data;
        })
        .catch((e) => {
            console.error('Error loading all system role-permissions!', e);
        });

    if (systemRolePermissions !== null) {
        return systemRolePermissions;
    }

    return null;
}

export async function getRdiSystemRolePermissionsByPermissionId(permissionId) {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdirolepermissions/permission/' + permissionId;

    const rdiSystemRolePermissionsURL = axios.create({ baseURL: url });

    const systemRolePermissions = await rdiSystemRolePermissionsURL.get('')
        .then(response => {
            const data = response.data

            return data;
        })
        .catch((e) => {
            console.error('Error loading all system role-permissions!', e);
        });

    if (systemRolePermissions !== null) {
        return systemRolePermissions;
    }

    return null;
}

export async function getRdiUserRoles(surveysUserId) {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiuserroles/surveysuser/' + surveysUserId;

    const rduUserRolesURL = axios.create({ baseURL: url });

    const userRoles = await rduUserRolesURL.get('')
        .then(response => {
            const data = response.data

            return data;
        })
        .catch((e) => {
            console.error('Error loadiing user roles!', e);
        });

    if (userRoles !== null) {
        return userRoles;
    }

    return null;
}

export async function getRdiUserPermissions(surveysUserId) {

    let url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiuserpermissions/surveysuser/' + surveysUserId;

    const rduUserPermissionsURL = axios.create({ baseURL: url });

    const userPermissions = await rduUserPermissionsURL.get('')
        .then(response => {
            const data = response.data

            return data;
        })
        .catch((e) => {
            console.error('Error loading user permissions!', e);
        });

    if (userPermissions !== null) {
        return userPermissions;
    }

    return null;
}

/**
 * Save Permission
 * @param {map} body - map.
 * @returns {string}
 */
export async function savePermission(body) {

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    };

    const result = await axios.post(ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdipermission/save', body, { headers })
        .then(response => {
            return response.data
        })
        .catch((e) => {
            console.error('There was an error!', e);
            return 'Permission save error'
        });

    return result
}

/**
 * Save Role
 * @param {map} body - map.
 * @returns {string}
 */
export async function saveRole(body) {

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    };

    const result = await axios.post(ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdirole/save', body, { headers })
        .then(response => {
            return response.data
        })
        .catch((e) => {
            console.error('There was an error!', e);
            return 'Role save error'
        });

    return result
}

/**
 * Remove Permission from Role
 * @param Long roleId, Long permissionId, Long surveysUserId - map.
 * @returns {string}
 */
export async function removePermissionFromRole(roleId, permissionId, surveysUserId) {

    const url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdirolepermissions/role/' + roleId + '/permission/' + permissionId + '/actionby/' + surveysUserId;

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'DELETE,OPTIONS'
    };

    try {
        const response = await axios.delete(url, { headers });
        return response.data;
    } catch (error) {
        console.error('There was an error!', error);
        return 'Permission delete error';
    }
}

/**
 * Remove Permission from User
 * @param Long surveysUserId, Long permissionId, Long actionById - map.
 * @returns {string}
 */
export async function removePermissionFromUser(surveysUserId, permissionId, actionById) {

    const url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiuserpermissions/user/' + surveysUserId + '/permission/' + permissionId + '/actionby/' + actionById;

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'DELETE,OPTIONS'
    };

    try {
        const response = await axios.delete(url, { headers });
        return response.data;
    } catch (error) {
        console.error('There was an error!', error);
        return 'Permission delete error';
    }
}

/**
 * Remove Role from User
 * @param Long surveysUserId, Long roleId, Long actionById - map.
 * @returns {string}
 */
export async function removeRoleFromUser(surveysUserId, roleId, actionById) {

    const url = ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiuserroles/user/' + surveysUserId + '/role/' + roleId + '/actionby/' + actionById;

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'DELETE,OPTIONS'
    };

    try {
        const response = await axios.delete(url, { headers });
        return response.data;
    } catch (error) {
        console.error('There was an error!', error);
        return 'Role delete error';
    }
}

/**
 * Update RolePermissions
 * @param {map} body - map.
 * @returns {string}
 */
export async function saveRolePermission(body) {

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    };

    const result = await axios.post(ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdirolepermissions/save', body, { headers })
        .then(response => {
            return response.data
        })
        .catch((e) => {
            console.error('There was an error!', e);
            return 'Role save error'
        });

    return result
}

/**
 * SaveUserPermissions
 * @param {map} body - map.
 * @returns {string}
 */
export async function saveUserPermissions(body) {

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    };

    const result = await axios.post(ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiuserpermissions/save', body, { headers })
        .then(response => {
            return response.data
        })
        .catch((e) => {
            console.error('There was an error!', e);
            return 'Role save error'
        });

    return result
}

/**
 * SaveUserroles
 * @param {map} body - map.
 * @returns {string}
 */
export async function saveUserRoles(body) {

    const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    };

    const result = await axios.post(ROLE_PERMISSION_MANAGEMENT_SERVICE + '/rdiuserroles/save', body, { headers })
        .then(response => {
            return response.data
        })
        .catch((e) => {
            console.error('There was an error!', e);
            return 'Role save error'
        });

    return result
}